<template>
    <div>
        <div class="titre contour_titre_acteurs">Acteurs</div>
        <div class="container_volet acteurs">
            <div class="caracteristiques">
                TRIER PAR<span class="fine">&nbsp;: </span>
                <div class="caracteristique" v-for="caracteristique in caracteristiques_acteurs" @click="tri_actif = caracteristique.slug" :class="{tri_actif: (caracteristique.slug == tri_actif)}" :key="caracteristique.slug">
                    {{ caracteristique.nom }}
                </div>
            </div>
            <div v-if="tri_actif == 'denomination'" class="container_acteurs denominations">
                <template v-for="(acteur, index) in acteurs_tries">
                    <div class='lettre' v-if="index == 0">123</div>
                    <div class='lettre' v-else-if="check_lettre(acteur.tri_lettre.charAt(0))">
                        {{ acteur.tri_lettre.charAt(0) }}
                    </div>
                    <div class="acteur" :key="acteur.id" :id="'actor-' + acteur.id">
                        <span @click="afficher_etiquettes($event, acteur.id)">{{ acteurs_par_id[acteur.id].patronyme }}</span>
                        <!-- <div class="fonction_acteur">{{ calculer_fonction(acteur.fonctions) }}</div> -->
                         <br>&nbsp;&nbsp;&nbsp;&nbsp;{{ calculer_fonction(acteur.fonctions) }}
                    </div>
                </template>
            </div>
            <div v-else-if="tri_actif == 'fonction'" class="container_acteurs fonctions">
                <div v-for="fonction in fonctions" :key="fonction.id">
                    <div class='fonction'>
                        {{ fonction.fonction }}
                    </div>
                    <div class="acteur" v-for="acteur in acteurs" :key="acteur.id" v-if="acteur.fonctions.indexOf(fonction.id) != -1" :id="'actor-' + acteur.id">
                        <span @click="afficher_etiquettes($event, acteur.id)">
                            {{ acteurs_par_id[acteur.id].patronyme }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="etiquettes_projet" @mouseout="masquer_etiquettes"></div>
        </div>
    </div>
</template>

<script>
    import { state } from '../../main.js';
    import { url_base } from '../../variables.js';
    // import Etiquette from './Etiquette_acteurs.vue';

    var lettre_courante = '';

    export default {
        data() {
            return {
                // fiches: state.fiches,
                acteurs: state.acteurs,
                acteurs_par_id: state.acteurs_par_id,
                fonctions_par_id: state.fonctions_par_id,
                fonctions: state.fonctions,
                caracteristiques_acteurs: [{
                        "slug": "denomination",
                        "nom": "Dénomination"
                    },
                    {
                        "slug": "fonction",
                        "nom": "Fonction"
                    }
                ],
                tri_actif: "denomination"
                // etiquettes_actives: false
            }
        },

        // components: {
        //     'v-etiquette': Etiquette
        // },

        created: function() {

        },
        computed: {
            acteurs_tries: function() {
                var liste_acteurs = Object.values(this.acteurs);

                var retour_acteurs = _.orderBy(liste_acteurs, function(item) {
                    if (item.type == "morale") {
                        item.tri_lettre = item.patronyme;
                        return nettoyer_accent(item.patronyme.toLowerCase());
                    } else {
                        item.tri_lettre = item.nom;
                        return nettoyer_accent(item.nom.toLowerCase());
                    }
                }, "DESC");
                return retour_acteurs;
            }
        },

        methods: {


            check_lettre(lettre) {
                if (!verifier_nombre(lettre)) {
                    if (lettre_courante != nettoyer_accent(lettre)) {
                        lettre_courante = nettoyer_accent(lettre);
                        return true;

                    } else {
                        return false;
                    }
                }
            },

            calculer_fonction(ids) {
                var retour = "";
                for (var i = 0; i < ids.length; i++) {
                    let id = ids[i];
                    retour += this.fonctions_par_id[id] + ", ";
                }

                retour = retour.substring(0, retour.length - 2);
                return retour;
            },

            afficher_etiquettes(event, id) {
                
                let pos_x = event.pageX;
                let pos_y = event.pageY+$(".container_volet.acteurs").scrollTop()

                if (window.innerWidth - pos_x > 250) {
                    $(".etiquettes_projet").css({
                        "top": pos_y - 15 + "px",
                        "left": pos_x - 80 + "px",
                    }).removeClass("droite");
                } else {
                    $(".etiquettes_projet").css({
                        "top": pos_y - 15 + "px",
                        "left": pos_x - 320 + "px",
                    }).addClass("droite");
                }

                $(".etiquettes_projet").html("");
                for (var i = 0; i < state.fiches.length; i++) {
                    let fiche = state.fiches[i];
                    let acteurs = fiche.acteurs;

                    for (var j = 0; j < acteurs.length; j++) {
                        if (acteurs[j] == id) {
                            //console.log(fiche.slug)
                            const element = document.createElement('div');
                            element.className = "etiquette";
                            element.textContent = fiche.titre;
                            element.addEventListener("click", () => {
                                this.$router.push(url_base+ 'acteurs/' + fiche.slug);
                            });
                            $(".etiquettes_projet").append(element);

                            var sep = document.createElement("div");
                            sep.classList.add("etiquette-sep");
                            sep.innerHTML = " ";
                            $(".etiquettes_projet").append(sep);                            
                        }
                    }
                }
                $(".etiquettes_projet").show();

            },
            masquer_etiquettes(event) {
                if(event.relatedTarget){
                    if(event.relatedTarget.className != "etiquettes_projet" && event.relatedTarget.className != "etiquette") {
                        $(".etiquettes_projet").hide();
                    }
                }
                
            }

        }
    };

    function verifier_nombre(caractere) {
        if (caractere.trim() === '') {
            return false
        }
        return caractere - 0 === caractere * 1
    }

    function nettoyer_accent(caractere) {
        return caractere.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    }
</script>

<style>

    .contour_titre_acteurs {
        text-shadow:
            -2px -2px 0 var(--couleur-acteurs),
            2px -2px 0 var(--couleur-acteurs),
            -2px 2px 0 var(--couleur-acteurs),
            2px 2px 0 var(--couleur-acteurs);
    }

    .acteurs {
        background-color: var(--couleur-acteurs);
        padding-top: 100px;
        padding-left: var(--tbm);
        padding-right: 120px;
        padding-bottom:200px;
    }


    .container_acteurs {
        columns: 250px;
        column-rule: solid 2px black;
        white-space: normal;
    }

    .lettre,
    .fonction {
        text-align: bottom;
        font-size: 45px;
        line-height: 50px;
        margin-top: 5px;
        text-align: center;
        font-family: var(--font-family);
        border-bottom: 2px dotted black;
        margin-bottom: var(--tbm);
        padding-bottom: 0px;
        break-inside: avoid-column;
    }

    .fonction {
        font-size: var(--corps-titre);
        line-height: var(--interlignage-titre);
        text-transform: uppercase;
    }

    .acteur+.lettre,
    .acteur+.fonction,
    .fonction {
        margin-top: 32px;
        /*background-color: red;*/
    }

    .fonctions>div:first-child>.fonction {
        margin-top: 0;

    }

    .acteur {
        break-inside: avoid-column;
        margin-bottom: 1.5em;
    }

    .acteur>span {
        line-height: var(--interlignage-courant);
        text-transform: uppercase;
        cursor: pointer;
    }

    .acteur>span:hover {
        text-decoration: underline;
        /*border-bottom: 1.5px solid black;*/
        /*padding-bottom: 1.5px;*/
    }

    .fonctions .acteur {
        margin-bottom: 0px;
        margin-left: 15px;
    }

    .fonctions .acteur>span {
        text-transform: none;
        margin-left: -15px;
    }

    .acteur>.fonction_acteur {
        margin-left: 30px;
    }


    .caracteristiques {
        position: absolute;
        top: -1px;
        left: 250px;
        z-index: 3;
        padding-top: var(--interlignage-courant);
        padding-left: var(--interlignage-courant);
        padding-bottom: 6px;
        padding-right: var(--interlignage-courant);
        background-color: transparent;
        text-transform: uppercase;
        font-size: var(--corps-petit);
        line-height: var(--interlignage-petit);
    }

    .caracteristique {
        display: inline-block;
        margin-left: 30px;
        cursor: pointer;
    }

    .tri_actif,
    .caracteristique:hover {
        padding-bottom: 0px;
        border-bottom: 1.5px solid black;
    }

    .etiquettes_projet {
        position: absolute;
        z-index: 3;
        margin-left: 0px;
        width: 250px;
        display: none;
    }

    .etiquettes_projet.droite {
        padding-left: 0px;
        padding-right: 20px;
    }

    .droite>.etiquette {
        float: right;
    }

    .etiquette {
        float: left;
        clear: both;
        /*padding-top: 6px;
        padding-bottom: 6px;
        padding-left: 4px;
        padding-right: 4px;*/
        /*text-transform: uppercase;*/
        background-color: white;
        /*border: 2px solid black;*/
        width: auto;
        height: 27px;
        margin-top: -2px;
        cursor: pointer;
        max-width: 250px;
        text-overflow: ellipsis;
        overflow: hidden;

        /*JDB*/
        background-color: white;
        width: auto;
        max-width: 60vw;
        margin-left: calc(39px / 6);
        pointer-events: all;
        padding: 4px 4px;
        -webkit-box-shadow: 0 0 0 1px black;
        box-shadow: 0 0 0 1px black;
        margin-bottom: 1px;
        height: 27px;
    }

    .etiquette:first-child {
        margin-top: 0px;
    }

    .etiquette:hover {
        background-color: black;
        color: white;
    }
    .container_volet.acteurs{
        /*background-color: red;*/
        /*width: 100%;*/
        padding-right: calc(var(--interlignage-courant));
        padding-bottom: 100px;
    }
</style>